import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { EASE } from '../../../lib/motion';
import styles from '../Home.module.css';

/**
 * Film-leader countdown dial for the getting-started steps: a hairline
 * ring with cardinal ticks, a serif numeral, and a gold arc that
 * sweeps in on scroll — each step fills a third further, so the dial
 * completes on step 03. Decorative (the step index is in the kicker
 * text); static under prefers-reduced-motion.
 */
const StepDial: React.FC<{ step: string; sweep: number; index: number }> = ({
  step,
  sweep,
  index,
}) => {
  const reduced = useReducedMotion();

  return (
    <div className={styles.stepDial} aria-hidden="true">
      <svg viewBox="0 0 96 96" className={styles.stepDialSvg} fill="none">
        <circle cx="48" cy="48" r="42" className={styles.dialRing} />
        <path
          d="M48 0v7M48 89v7M0 48h7M89 48h7"
          className={styles.dialTicks}
        />
        {reduced ? (
          <circle
            cx="48"
            cy="48"
            r="42"
            pathLength={1}
            strokeDasharray={`${sweep} 1`}
            className={styles.dialArc}
          />
        ) : (
          <motion.circle
            cx="48"
            cy="48"
            r="42"
            className={styles.dialArc}
            initial={{ pathLength: 0 }}
            whileInView={{ pathLength: sweep }}
            viewport={{ once: true, margin: '-60px' }}
            transition={{
              duration: 1.1,
              delay: 0.3 + index * 0.18,
              ease: EASE,
            }}
          />
        )}
      </svg>
      <span className={styles.stepDialNumeral}>{step}</span>
    </div>
  );
};

export default StepDial;
